import Cesium from 'cesium';

function createGeoJsonDataSource(name, {
  stroke = [255.0, 255.0, 255.0, 255.0],
  fill = [0.0, 0.0, 0.0, 0.0],
  strokeWidth = 1,
} = {}) {
  return Cesium.GeoJsonDataSource.load(name, {
    stroke: makeCesiumColor(stroke),
    fill: makeCesiumColor(fill),
    strokeWidth});
}

function makeCesiumColor(components) {
  // Normalize all components that were specified and pass them to Cesium.
  return new Cesium.Color(...components.map(comp => comp / 255.0));
}

export default createGeoJsonDataSource;



// WEBPACK FOOTER //
// ./src/core/createGeoJsonDataSource.js